module.exports = __webpack_public_path__ + "static/media/me_1.792e035e.png";